'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { useStore } from 'zustand';

import { CartClearConfirmationModal } from './cart-clear-confirmation-modal.component';

import {
  cancelCartClearConfirmation,
  cartClearConfirmationStore,
  confirmCartClearConfirmation,
} from '@/store/cart/cart-clear-confirmation.store';

export function CartClearConfirmationHost() {
  const isOpen = useStore(cartClearConfirmationStore, (state) => state.isOpen);
  const reason = useStore(cartClearConfirmationStore, (state) => state.reason);

  const pathname = usePathname();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    if (prevPathnameRef.current === pathname) {
      return;
    }

    prevPathnameRef.current = pathname;
    cancelCartClearConfirmation();
  }, [pathname]);

  return (
    <CartClearConfirmationModal
      open={isOpen}
      reason={reason}
      onConfirm={confirmCartClearConfirmation}
      onCancel={cancelCartClearConfirmation}
    />
  );
}
